import { GET_USER_SUCCESS, GET_USER_ERROR, GET_USER_BADGE_SUCCESS, GET_USER_BADGE_ERROR } from '../actions/constants'

const initialState = {
  userBadges: [],
  errors: [],
  userBadge: null,
  userBadgeError: [],
}

const user = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_USER_SUCCESS:
      return {
        ...state,
        userBadges: payload,
        errors: [],
      }
    case GET_USER_ERROR:
      return {
        ...state,
        errors: payload,
        userBadges: [],
      }
    case GET_USER_BADGE_SUCCESS:
      return {
        ...state,
        userBadge: payload,
        userBadgeError: [],
      }
    case GET_USER_BADGE_ERROR:
      return {
        ...state,
        userBadgeError: payload,
        userBadge: null,
      }
    default:
      return state
  }
}

export default user
